import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function AspMethodologyPage() {
  return (
    <CustomerMethodologyPage
      title="Antibiotic stewardship — overview"
      description="How WeConsult Rx supports antibiotic stewardship documentation for skilled nursing facilities."
      path="/trust/asp-methodology"
    >
      <p>
        The antibiotic stewardship module helps consultant pharmacists document
        and track stewardship activities aligned with CMS F881 and CDC Core
        Elements for antibiotic stewardship in nursing homes.
      </p>
      <h2>What it covers</h2>
      <ul>
        <li>Facility-level antibiotic use policies and tracking.</li>
        <li>Course documentation with start/stop dates and indication.</li>
        <li>Stewardship review checkpoints tied to regulatory references.</li>
      </ul>
      <h2>How it helps</h2>
      <p>
        Structured documentation makes survey readiness and medical director
        reporting straightforward — every field maps to a recognized standard.
      </p>
    </CustomerMethodologyPage>
  );
}
